// https://github.com/codypearce/material-bread/blob/master/src/Components/Drawer/Drawer.js
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Animated, Dimensions, View, SafeAreaView, StyleSheet, Platform, TouchableWithoutFeedback, } from 'react-native';
const styles = StyleSheet.create({
    fullWidthContainer: {
        flex: 1,
        backgroundColor: 'white',
    },
    masafeAreaViewin: {
        position: 'absolute',
        left: 0,
        top: 5,
        zIndex: 0,
    },
    container: {
        position: 'absolute',
        left: 0,
        zIndex: 0,
    },
    drawer: {
        position: 'absolute',
        zIndex: 100,
        borderRightWidth: 1,
        borderRightColor: 'rgba(0,0,0,.12)',
        borderStyle: 'solid',
        backgroundColor: 'white',
    },
    drawerHeader: {
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: 'rgba(0,0,0,.12)',
        paddingHorizontal: 16,
        paddingVertical: 18,
    },
    drawerHeaderAvatarContainer: {
        marginBottom: 20,
    },
    drawerHeaderTitle: {
        fontSize: 20,
        fontWeight: '500',
        color: 'rgba(0,0,0,.87)',
    },
    drawerHeaderSubtitle: {
        marginTop: 4,
        fontSize: 12,
        color: 'rgba(0,0,0,.67)',
    },
    drawerItem: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'transparent',
        height: 40,
        borderRadius: 4,
        paddingHorizontal: 8,
        zIndex: 10,
    },
    drawerItemActive: {
        backgroundColor: 'rgba(30, 136, 229, .2)',
        color: '#1e88e5',
    },
    drawerItemText: {
        fontSize: 14,
        color: 'rgba(0,0,0,.87)',
        fontWeight: '500',
        zIndex: 10,
    },
    drawerItemIcon: {
        color: 'grey',
    },
});
const shadowConversion = [
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 0,
        },
        shadowOpacity: 0,
        shadowRadius: 1.0,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.18,
        shadowRadius: 1.0,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 1.41,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.22,
        shadowRadius: 2.22,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.27,
        shadowRadius: 4.65,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.29,
        shadowRadius: 4.65,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.3,
        shadowRadius: 4.65,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.32,
        shadowRadius: 5.46,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 5,
        },
        shadowOpacity: 0.36,
        shadowRadius: 6.68,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 0.37,
        shadowRadius: 7.49,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 0.39,
        shadowRadius: 8.3,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 7,
        },
        shadowOpacity: 0.41,
        shadowRadius: 9.11,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 7,
        },
        shadowOpacity: 0.43,
        shadowRadius: 9.51,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 8,
        },
        shadowOpacity: 0.44,
        shadowRadius: 10.32,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 8,
        },
        shadowOpacity: 0.46,
        shadowRadius: 11.14,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 9,
        },
        shadowOpacity: 0.48,
        shadowRadius: 11.95,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 9,
        },
        shadowOpacity: 0.5,
        shadowRadius: 12.35,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 10,
        },
        shadowOpacity: 0.51,
        shadowRadius: 13.16,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 10,
        },
        shadowOpacity: 0.53,
        shadowRadius: 13.97,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 11,
        },
        shadowOpacity: 0.55,
        shadowRadius: 14.78,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 11,
        },
        shadowOpacity: 0.57,
        shadowRadius: 15.19,
    },
    {
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 12,
        },
        shadowOpacity: 0.58,
        shadowRadius: 16.0,
    },
];
function shadow(elevation) {
    return Platform.OS !== 'android'
        ? shadowConversion[elevation]
        : { elevation };
}
const needsSafeAreaDefault = Platform.OS === 'ios' && parseInt(Platform.Version, 10);
class Drawer extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            screenWidth: Dimensions.get('window').width,
            screenHeight: Dimensions.get('window').height,
            drawerWidth: 240,
            expanded: false,
            backdropFade: new Animated.Value(0),
            leftOffset: new Animated.Value(this.props.orientation === 'right' ? 5000 : 0),
            appbarHeight: 0,
            appbarWidth: 0,
        };
        this.openDrawer = () => {
            const { drawerWidth, leftOffset, backdropFade, screenWidth } = this.state;
            const { animationTime, scrimOpacity, orientation } = this.props;
            let actualWidth = 0;
            actualWidth = Platform.OS === 'web' ? document.documentElement.clientWidth : screenWidth;
            Animated.parallel([
                Animated.timing(leftOffset, {
                    toValue: orientation === 'right' ? actualWidth : drawerWidth,
                    duration: animationTime,
                    useNativeDriver: false,
                }),
                Animated.timing(backdropFade, {
                    toValue: scrimOpacity,
                    duration: animationTime,
                    useNativeDriver: false,
                }),
            ]).start();
        };
        this.closeDrawer = () => {
            const { animationTime } = this.props;
            const { backdropFade, leftOffset } = this.state;
            Animated.parallel([
                Animated.timing(leftOffset, {
                    toValue: 5000,
                    duration: animationTime,
                    useNativeDriver: false,
                }),
                Animated.timing(backdropFade, {
                    toValue: 0,
                    duration: animationTime,
                    useNativeDriver: false,
                }),
            ]).start();
        };
        this.handleResize = () => {
            const screenHeight = Platform.OS === 'web' ? window.innerHeight : Dimensions.get('window').height;
            const screenWidth = Platform.OS === 'web' ? '100%' : Dimensions.get('window').width;
            this.setState({
                screenHeight: screenHeight,
                screenWidth: screenWidth,
            });
        };
        this._onAppbarLayout = e => {
            const { width, height } = e.nativeEvent.layout;
            this.setState({
                appbarWidth: width,
                appbarHeight: height,
            });
        };
    }
    componentDidMount() {
        const { pageWidth, pageHeight, widthPercentage, width } = this.props;
        Platform.OS === 'web' && window.addEventListener('resize', this.handleResize);
        let screenWidth = Platform.OS === 'web' ? '100%' : Dimensions.get('window').width;
        let screenHeight = Dimensions.get('window').height;
        if (pageWidth)
            screenWidth = pageWidth;
        if (pageHeight)
            screenHeight = pageHeight;
        let drawerWidth = Platform.OS === 'web'
            ? this.state.drawerWidth
            : screenWidth * (widthPercentage || 0.45);
        if (width)
            drawerWidth = width;
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            screenWidth,
            screenHeight,
            drawerWidth,
        });
    }
    componentDidUpdate() {
        const { open } = this.props;
        if (open) {
            this.openDrawer();
        }
        else {
            this.closeDrawer();
        }
    }
    componentWillUnmount() {
        Platform.OS === 'web' && window.removeEventListener('resize', this.handleResize);
    }
    _renderAppBar() {
        const { appbar } = this.props;
        return (<View style={{ zIndex: 1200 }} onLayout={this._onAppbarLayout}>
        {appbar}
      </View>);
    }
    _renderScrim() {
        const { open, scrim, scrimColor, type, scrimStyles, preventCloseOnBackdropPress, onClose } = this.props;
        const { backdropFade, screenWidth, screenHeight, appbarHeight, } = this.state;
        let scrimColorImplemented = type === 'push' ? 'transparent' : 'black';
        if (scrimColor)
            scrimColorImplemented = scrimColor;
        function onCloseModal() {
            if (!preventCloseOnBackdropPress) {
                onClose && onClose();
            }
        }
        return (<Animated.View useNativeDriver={false} style={[
            styles.container,
            {
                backgroundColor: scrim ? scrimColorImplemented : 'transparent',
                opacity: backdropFade,
                zIndex: open ? 10 : 0,
                width: screenWidth,
                height: screenHeight,
                top: appbarHeight,
                position: Platform.OS === 'web' ? 'fixed' : 'absolute',
            },
            scrimStyles,
        ]}>
        <TouchableWithoutFeedback onPress={onCloseModal}>
          <View style={[
            styles.container,
            {
                width: screenWidth,
                height: screenHeight,
                backgroundColor: scrim ? scrimColorImplemented : 'transparent',
            },
        ]}/>
        </TouchableWithoutFeedback>
      </Animated.View>);
    }
    _renderAppContent() {
        const { children, appbar, type, open, contentContainerStyle } = this.props;
        const { leftOffset, drawerWidth } = this.state;
        const isPush = type === 'push';
        const isPermanent = type === 'permanent';
        if (isPush || isPermanent) {
            return (<View style={contentContainerStyle}>
          {appbar ? this._renderAppBar() : null}
          <Animated.View useNativeDriver={false} style={{
                transform: [{ translateX: leftOffset }],
                flex: 1,
                width: open && Platform.OS === 'web' && isPermanent
                    ? `calc(100% - ${drawerWidth}px)`
                    : '100%',
            }}>
            {children}
          </Animated.View>
        </View>);
        }
        return (<View style={[{ height: '100%' }, contentContainerStyle]}>
        {appbar ? this._renderAppBar() : null}
        <View style={{ height: '100%' }}>{children}</View>
      </View>);
    }
    _renderDrawer() {
        const { drawerContent, type, open, drawerStyle, fullHeight, position, } = this.props;
        const { drawerWidth, screenHeight, leftOffset, appbarHeight } = this.state;
        const isPush = type === 'push';
        const isPermanent = type === 'permanent';
        const offsetDrawerShadow = isPermanent || open ? 0 : 5;
        const shadowImplemented = isPush || isPermanent ? shadow(0) : shadow(16);
        return (<Fragment>
        <Animated.View useNativeDriver={false} style={[
            styles.drawer,
            {
                position: position,
                width: drawerWidth,
                left: -drawerWidth - offsetDrawerShadow,
                top: appbarHeight,
                height: fullHeight ? '100%' : screenHeight,
                transform: [{ translateX: leftOffset }],
                ...shadowImplemented,
            },
            drawerStyle,
        ]}>
          {drawerContent}
        </Animated.View>

        {isPermanent ? null : this._renderScrim()}
        {this._renderAppContent()}
      </Fragment>);
    }
    render() {
        const { style, testID, needsSafeArea } = this.props;
        const { screenWidth } = this.state;
        if (needsSafeArea) {
            return (<SafeAreaView style={[
                styles.safeAreaView,
                { position: 'relative', width: screenWidth, overflow: 'hidden' },
                style,
            ]}>
          {this._renderDrawer()}
        </SafeAreaView>);
        }
        return (<View style={[
            styles.fullWidthContainer,
            {
                position: 'relative',
                width: screenWidth,
                overflow: 'hidden',
            },
            style,
        ]} testID={testID}>
        {this._renderDrawer()}
      </View>);
    }
}
Drawer.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    type: PropTypes.string,
    drawerContent: PropTypes.node,
    children: PropTypes.node,
    animationTime: PropTypes.number,
    pageHeight: PropTypes.number,
    pageWidth: PropTypes.number,
    widthPercentage: PropTypes.number,
    width: PropTypes.number,
    fullHeight: PropTypes.bool,
    position: PropTypes.string,
    needsSafeArea: PropTypes.bool,
    appbar: PropTypes.node,
    scrim: PropTypes.bool,
    scrimColor: PropTypes.string,
    scrimOpacity: PropTypes.number,
    drawerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    scrimStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    testID: PropTypes.string,
    theme: PropTypes.object,
    orientation: PropTypes.string,
};
Drawer.defaultProps = {
    open: false,
    animationTime: 200,
    scrimOpacity: 0.4,
    scrim: true,
    type: 'modal',
    position: 'absolute',
    needsSafeArea: needsSafeAreaDefault,
    orientation: 'right',
};
export default Drawer;
//# sourceMappingURL=CustomDrawer.js.map